import React, { useContext, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

//Context
import BrandingContext from "../BrandingContext";
import AppLabelsContext from "../AppLabelsContext";

//UI Components
import { AppFooterSubnav } from "./AppFooterSubnav";

//CSS
import "./AppFooterItem.css";
import GCCartContext from "../../GiftCard/GCCartContext";

export const AppFooterItem = (props) => {
  const {
    name,
    displayName,
    isLink,
    linkPathname,
    isActive,
    icon,
    subnavItems,
    ariaLabel,
    isAction,
    action,
  } = props.module;

  const appLabels = useContext(AppLabelsContext);
  const branding = useContext(BrandingContext);
  const gcCart = useContext(GCCartContext)

  const [isSubnav, setIsSubnav] = useState(false);
  const [showDotInidcatior, setShowDotIndicatior] = useState(false)
  const handleTopLevelNavItemClick = () => {
    setIsSubnav(!isSubnav);
  };

  const handleOnClick = () => {
    if (document.getElementById("mobile-hamburger-menu-container")) {
      document.getElementById("mobile-hamburger-menu-container").style.display = "none";
    }
    action();
  };

  const settingsClass = name === "settings" ? " footer__nav-item--settings" : "";

  const activeClass = isActive ? " footer__nav-item--active-module" : "";

  /** Close the sub-navigation when user clicks on a subnav item and navigates away */
  const location = useLocation();
  useEffect(() => {
    setIsSubnav(false);
  }, [location]);

  useEffect(() => {
    if (name === "gift-card" && !location.pathname.includes("gift-card") && gcCart.value && gcCart.value.length > 0) {
      setShowDotIndicatior(true)
    }
  }, [])

  return (
    <li className={`footer__nav-item${settingsClass}${activeClass}`}>
      {isLink ? (
        <Link
          to={linkPathname}
          className="footer__nav-link"
          style={{
            color: isActive
              ? branding["header-footer-active-text-colour"]
              : branding["footer-text-and-icon-colour"],

            fill: isActive
              ? branding["header-footer-active-text-colour"]
              : branding["footer-text-and-icon-colour"],

            strokeWidth: name === "home" ? "0px" : "1px",
          }}
          onClick={() => {
            if (document.getElementById("mobile-hamburger-menu-container")) {
              document.getElementById("mobile-hamburger-menu-container").style.display = "none";
            }
          }}
        >
          {showDotInidcatior ?
            <div className="giftCardMobileLinkDotIndicator" style={{ position: "relative" }}>
              {icon}
              <span></span>
            </div>
            :
            icon}


          <span className="footer__nav-item-title">{displayName}</span>
        </Link>
      ) : (
        <>
          {isAction ? (
            <button
              onClick={handleOnClick}
              className={`button footer__nav-button${activeClass}`}
              style={{
                color: isActive
                  ? branding["header-footer-active-text-colour"]
                  : branding["footer-text-and-icon-colour"],
                fill: isActive
                  ? branding["header-footer-active-text-colour"]
                  : branding["footer-text-and-icon-colour"],
              }}
              data-name={name}
              aria-label={`${
                isSubnav ? appLabels["general"]["hide"] : appLabels["general"]["show"]
              } ${ariaLabel}`}
              aria-expanded={isSubnav}
            >
              {icon}
              <span className="footer__nav-item-title">{displayName}</span>
            </button>
          ) : (
            <button
              onClick={handleTopLevelNavItemClick}
              className={`button footer__nav-button${activeClass}`}
              style={{
                color: isActive
                  ? branding["header-footer-active-text-colour"]
                  : branding["footer-text-and-icon-colour"],
                fill: isActive
                  ? branding["header-footer-active-text-colour"]
                  : branding["footer-text-and-icon-colour"],
              }}
              data-name={name}
              aria-label={`${
                isSubnav ? appLabels["general"]["hide"] : appLabels["general"]["show"]
              } ${ariaLabel}`}
              aria-expanded={isSubnav}
            >
              {icon}
              <span className="footer__nav-item-title">{displayName}</span>
            </button>
          )}
        </>
      )}
      {isSubnav && (
        <AppFooterSubnav
          name={name}
          subnavItems={subnavItems}
          closeSubnav={() => setIsSubnav(false)}
        />
      )}
    </li>
  );
};
